import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { Fragment } from 'react';
import ValueDisplay from '../valueDisplay/ValueDisplay';

const isEmptyValue = (val: any) =>
  val === null ||
  val === undefined ||
  (typeof val === 'string' && (val.trim() === '' || val.trim().toLowerCase() === 'empty'));

const toTitleCase = (str: string) =>
  str
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

export default function ObjectInfo(props: Template.ObjectInfo.Import) {
  const { translate } = getLocales();
  return (
    <div style={{ width: Theme.Size.fill, ...props.style }}>
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        <h3>{props.objectName}</h3>
        {props.objectSubtitle}
      </div>
      <DataObjectMap
        data={props.object}
        render={({ data, key, isLast }) => {
          if (isEmptyValue(data)) return null;

          // TODO: Add 'amt', 'amount', 'taxAmt', 'taxAmount' to regex!
          const isPrice = (key as string).toLowerCase().match(/cost|price|cad/g);
          const finalKey = (key as string).replace(/(CAD|Utc)$/g, '');
          const labelRaw = props.disableTranslation ? finalKey : translate(finalKey);
          const label = toTitleCase(String(labelRaw));

          return (
            typeof data !== 'object' && (
              <Fragment key={finalKey}>
                {label}:&nbsp;
                <ValueDisplay
                  value={isPrice && typeof data === 'number' ? `${(data as number).toFixed(2)}$` : data}
                  objKey={finalKey}
                  disableTranslation={true}
                  subcomponents={{
                    validValue: {
                      style: { fontWeight: 'bold' },
                    },
                  }}
                />
                {!isLast && <br />}
              </Fragment>
            )
          );
        }}
      />
    </div>
  );
}
